// const APP_FONT = {
//   VARIABLE: 'Commissioner',
// };

export const initialModule = {
  /**
   * Asynchronously loads theme CSS and fonts if the theme CSS path is available.
   *
   * This function attempts to load the theme CSS using a lazy style loader, followed by
   * loading the critical and variable fonts using a lazy font loader. If any error occurs
   * during the loading process, it logs the error and rethrows it.
   *
   * @throws Will throw an error if loading the CSS or fonts fails.
   */
  async load(): Promise<void> {
    try {
      // const { lazyFontLoader } = await import(
      //   '@ms/shared/utils/loaders/lazy-font-loader'
      // );
      // lazyFontLoader(APP_FONT.VARIABLE);
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error('🚨 Error loading initial module:', error);

      throw error;
    }
  },
};
